<template>
    <div class="d-sm-block d-lg-inline-block">
        <span class="sau-font sm d-inline-block" :class="animationClass">
            <slot name="msg"></slot>
        </span>
    </div>
</template>

<script>
export default {
    data(){
        return{
            animationClass:'d-none'
        }
    },
    created() {
        this.loadAction();
    },
    methods:{
        loadAction(){
            this.animationClass = 'animated fadeInDown';
            setTimeout(() => {
                this.animationClass = 'animated fadeOutDown d-none';
            }, 3500);
        }
    }
}
</script>

<style>
</style>
